import abi from "./contract/GlobalPool.json";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import Buy from "./component/buy"



import "./copy.png";
import Buy3 from "./component/buy3";
import Buy1 from "./component/buy1";
import Buy2 from "./component/buy2";




function App() {
  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[direct1,setDirect1]=useState("None");
 const[level1,setLevel1]=useState("None");
  const[wlevel1,setLevelw1]=useState("None");

  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[wlevel,setLevelw]=useState("None");
  const[plevel,setLevelp]=useState("None");
  const[pack,setpackage]=useState("None");
  const[pack3,setpackage3]=useState("None");
  const[pack1,setpackage1]=useState("None");
  const[refer,setrefer]=useState("None");
const [tasks,setTasks] = useState([]);
const [tasks1,setTasks1] = useState([]);
const [tt,settt]=useState("None");
const [wid1,setwid1]=useState("None");
const [tt4,settt4]=useState("None");
const[dd,setDD]=useState("None");
const[dd1,setDD1]=useState("None");
const[dd2,setDD2]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[upd,setupd]=useState("None");
const [tt1,settt1]=useState("None");
const [roi,seroi]=useState("None");
const [roi1,seroi1]=useState("None");
const [roi2,seroi2]=useState("None");
const [a1,sea1]=useState("None");
const [a2,sea2]=useState("None");
const [a3,sea3]=useState("None");
const [tt2,settt2]=useState("None");
const [tt3,settt3]=useState("None");

const [tt12,settt12]=useState("None");
const [tt13,settt13]=useState("None");

const [l1,setl1]=useState("None");
const [b1,setb1]=useState("None");
const [l2,setl2]=useState("None");
const [b2,setb2]=useState("None");
const [l3,setl3]=useState("None");
const [b3,setb3]=useState("None");
const [l4,setl4]=useState("None");
const [b4,setb4]=useState("None");
const [l5,setl5]=useState("None");
const [b5,setb5]=useState("None");
const [l6,setl6]=useState("None");
const [b6,setb6]=useState("None");
const [l7,setl7]=useState("None");
const [b7,setb7]=useState("None");
const [l8,setl8]=useState("None");
const [b8,setb8]=useState("None");
const [l9,setl9]=useState("None");
const [b9,setb9]=useState("None");
const [l10,setl10]=useState("None");
const [b10,setb10]=useState("None");
const [l11,setl11]=useState("None");
const [b11,setb11]=useState("None");
const [l12,setl12]=useState("None");
const [b12,setb12]=useState("None");
const [l13,setl13]=useState("None");
const [b13,setb13]=useState("None");
const [l14,setl14]=useState("None");
const [b14,setb14]=useState("None");
const [l15,setl15]=useState("None");
const [b15,setb15]=useState("None");
const [lev,setlev]=useState("None");
const [pen,setpen]=useState("None");

const [reward,setreward]=useState("None");
const [reward1,setreward1]=useState("None");
const [reward2,setreward2]=useState("None");
const [reward3,setreward3]=useState("None");
const [reward4,setreward4]=useState("None");
const [reward5,setreward5]=useState("None");
const[reward6,setreward6]=useState("None");
const[reward7,setreward7]=useState("None");
const[reward8,setreward8]=useState("None");
const[reward9,setreward9]=useState("None");
const[reward10,setreward10]=useState("None");

const[x5,setx5]=useState("None");

const[x11,setx11]=useState("None");
const[x12,setx12]=useState("None");
const[x13,setx13]=useState("None");
const[x14,setx14]=useState("None");
const[x15,setx15]=useState("None");
const[x1,setx1]=useState("None");
const[x2,setx2]=useState("None");
const[x3,setx3]=useState("None");
const[x4,setx4]=useState("None");



  useEffect(() => {
    
    const connectWallet = async () => {
      
      const contractAddress = "0x25A0538cc7623F13323ed65321c6464176539ce5";
      const contractABI = abi.abi;
     
      const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('ref');
    console.log(myParam);
    document.querySelector("#name").value=myParam;
if(myParam == null)
  {
    document.querySelector("#name").value="0x288B280c1a0c0eb64DE2e4b49b5898afd0611997";
  }
  
  try {
    const { ethereum } = window;
  //  document.querySelector("#test").value = "0";
    if (ethereum) {
      const account = await ethereum.request({
        method: "eth_requestAccounts",
       
      });
     
      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      });

      window.ethereum.on("accountsChanged", () => {
        
        window.location.reload();
      });
          const provider = new ethers.providers.Web3Provider(ethereum);
        
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
        
        
        
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
      let alltasks = await contract.getMemos(account[0]);
      setTasks(alltasks);
      let alltasks1 = await contract.getMemos1(account[0]);
      setTasks1(alltasks1);
      const b =Number(alltasks[2]);
      const refer = (alltasks[1]);
     setrefer(refer);
     document.querySelector("#hid").value  = (alltasks[1]);
     const direct =Number(alltasks[2]);
     setDirect(direct);
     const direct1 =Number(alltasks[46]);
     setDirect1(direct1);
     const directs = Number(alltasks[3])/1000000000000000000;
     setDirects(directs);
     const level = Number(alltasks[4])/1000000000000000000;
     setLevel(level);

     const wlevel = Number(alltasks[13])/1000000000000000000;
     setLevelw(wlevel);

     const plevel = Number(alltasks[12])/1000000000000000000;
     setLevelp(plevel);
     
    
     const pack = Number(alltasks[6])/1000000000000000000 ;
     

setpackage(pack);


const lev = Number(alltasks[54])/1000000000000000000 ;
setlev(lev);


const pack3 = Number(alltasks[14])/1000000000000000000 ;
     

setpackage3(pack3);

const reward1 = Number(alltasks[49]) ;
setreward1(reward1);
const reward2 = Number(alltasks[50]) ;
setreward2(reward2);
const reward3 = Number(alltasks[51]) ;
setreward3(reward3);
const reward4 = Number(alltasks[52]) ;
setreward4(reward4);
const reward5 = Number(alltasks[53]) ;
setreward5(reward5);


            

const pack1 = Number(alltasks[5]) ;
document.querySelector("#pp").value  = Number(alltasks[5]);


setpackage1(pack1);



     setB(b);

     const upd = (Number(alltasks[7]) ) /1000000000000000000  ;
          
     setupd(upd);

     const x11 = (Number(alltasks[57]) ) /1000000000000000000  ;
          
     setx11(x11);

     const dd = Number(alltasks[56]);
          
     setDD(dd);

     const dd2 = Number(alltasks[56]);
          
     setDD2(dd2);

     const dd1 =  Date.now() / 1000;
     setDD1(dd1);


  
  
       
       

       
    // const roi1 = Number(alltasks[9]) / 100000;
          
    // seroi1(roi1);

    

    // document.querySelector("#wi1").value = roi2;
     
     const a1 = Number(alltasks1[0])-1;
          
     sea1(a1);
     const a3 = Number(alltasks1[2])/1000000000000000000;
          
     sea3(a3);
     const a2 = Number(alltasks1[1])/1000000000000000000;
     sea2(a2);   
     var rr = 0;
     const tt4 =  Number(alltasks[15])/1000000000000000000;
     settt4(tt4);
     

     const l1 = Number(alltasks[16]);
     setl1(l1);
     const l2 = Number(alltasks[17]);
     setl2(l2);

     const l3 = Number(alltasks[18]);
     setl3(l3);
     const l4 = Number(alltasks[19]);
     setl4(l4);
     const l5 = Number(alltasks[20]);
     setl5(l5);
     const l6 = Number(alltasks[21]);
     setl6(l6);
     const l7 = Number(alltasks[22]);
     setl7(l7);
     const l8 = Number(alltasks[23]);
     setl8(l8);
     const l9 = Number(alltasks[24]);
     setl9(l9);
     const l10 = Number(alltasks[25]);
     setl10(l10);
     const l11 = Number(alltasks[26]);
     setl11(l11);
     const l12 = Number(alltasks[27]);
     setl12(l12);
     const l13 = Number(alltasks[28]);
     setl13(l13);
     const l14 = Number(alltasks[29]);
     setl14(l14);
     const l15 = Number(alltasks[30]);
     setl15(l15);
     


     const b1 = Number(alltasks[31]);
     setb1(b1);
     const b2 = Number(alltasks[32]);
     setb2(b2);
     const b3 = Number(alltasks[33]);
     setb3(b3);
     const b4 = Number(alltasks[34]);
     setb4(b4);
     const b5 = Number(alltasks[35]);
     setb5(b5);
     const b6 = Number(alltasks[36]);
     setb6(b6);
     const b7 = Number(alltasks[37]);
     setb7(b7);
     const b8 = Number(alltasks[38]);
     setb8(b8);
     const b9 = Number(alltasks[39]);
     setb9(b9);
     const b10 = Number(alltasks[40]);
     setb10(b10);
     const b11 = Number(alltasks[41]);
     setb11(b11);
     const b12 = Number(alltasks[42]);
     setb12(b12);
     const b13 = Number(alltasks[43]);
     setb13(b13);
     const b14 = Number(alltasks[44]);
     setb14(b14);
     const b15 = Number(alltasks[45]);
     setb15(b15);
     
     

     const tt = Number(alltasks[47])/1000000000000000000;
     settt(tt);
     const wid1 = Number(alltasks[48])/1000000000000000000;
     setwid1(wid1);
     const pen = tt - wid1;
     setpen(pen);
  
     const tt3 = Number(alltasks[10])/1000000000000000000;
     settt3(tt3);
     const reward = reward1 + reward2 + reward3 + reward4 + reward5;
setreward(reward);
if(reward==1)
{
  const reward = 250;
  setreward(reward);
}
if(reward==2)
{
  const reward = 750;
  setreward(reward);
}
if(reward==3)
  {
    const reward = 1750;
    setreward(reward);
  }
  if(reward==4)
    {
      const reward = 4250;
      setreward(reward);
    }
    if(reward==5)
      {
        const reward = 9250;
        setreward(reward);
      }
     

     document.querySelector("#bal").value = tt3;
     const referlink = 'https://xyztoken.pro/?ref='+ account;
     setreflink(referlink);
     document.querySelector("#link").value =referlink;


const tt2 = 1440 - Math.trunc((dd1 - dd2)/60) ;
       
       settt2(tt2);

      if(tt2<0)
      {
        const tt2 = 0;
       
       settt2(tt2);
        const x5 = "Next Trade Pending" ;
       setx5(x5);
      }
      else
      {
         const x5 = "Trade Already Claimed" ;
       setx5(x5);
      }


      const tt12 = Math.floor(tt2/60) ;
       
       settt12(tt12);
       const tt13 = tt2%60 ;
       
       settt13(tt13);


        if(tt12<0)
      {
        const tt12 = "00";
       
       settt12(tt12);
      }

       if(tt13<0)
      {
        const tt13 = "00";
       
       settt13(tt13);
      }






console.log(pack);
     
        } else {
          alert("Please wait for network");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
   
    
    connectWallet();
    
    function myFunction() {
      
      var copyText = "hello";
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      
    
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.valueOf);
    }

  }, []);

 
  // console.log(state);
  return (
  <div>
    <input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    <input type="hidden" id ="tt2"></input>
    <input type="hidden" id ="wi1"></input>
    <input type="hidden" id ="roi"></input>
    <input type="hidden" id ="bal"></input>

     
    
      <section
      class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-24 px-6"
    >
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               BUY TOKENS
              </p>
              <br></br>
              <h3 class="text-white text-lg font-bold"><input type ="text" id ="test" style={{color:"black"}} width={"200px"} ></input></h3>
              <br></br>
              <p>  <Buy state={state}  /></p>
            </div>
          </div>
        
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               SELL TOKENS
              </p>
              <br></br>
              <h3 class="text-white text-lg font-bold"><input type ="text" id ="test1" style={{color:"black"}} width={"200px" } ></input></h3>
              <br></br>
              <p><Buy3 state={state}  /> </p>
            </div>
          </div>
         
        </div>
      </div>
       <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
              WITHDRAW
              </p>
              <br></br>
              <h3 class="text-white text-lg font-bold"><input type ="text" id ="test1nn" style={{color:"black"}} width={"200px"} ></input></h3>
              <br></br>
              <p> <Buy1 state={state}  />  </p>
            </div>
          </div>
         
        </div>
      </div>
<div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               MINT TOKENS
              </p>
              <br></br>
              <h3 class="text-white text-lg font-bold">
                
              Next Minting In
            
             <br></br>
            <p style={{fontSize:"1rem",lineHeight:"2rem"}} >
            {tt12} Hours and {tt13} Minutes
                </p>
                </h3>
              <br></br>
              <p>  <Buy2 state={state}  /></p>
            </div>
          </div>
        
        </div>
      </div>
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                INCOME
              </p>
              <h3 class="text-white text-lg font-bold"></h3>
            </div>
          </div>
          <div class="space-y-4">
           
              <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">LEADERSHIP INCOME </span>
              <span class="text-cyan-400 text-xs">{wlevel} USDT</span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">PERFORMANCE INCOME </span>
              <span class="text-pink-400 text-xs">{plevel} USDT</span>
            </div>
              <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Minting Bonus </span>
              <span class="text-pink-400 text-xs">{x11} XYZ Tokens</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-cyan-500/50 to-transparent shadow-[0_0_25px_rgba(6,182,212,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#081b25]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-cyan-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               WITHDRAW
              </p>
              <h3 class="text-white text-lg font-bold"></h3>
            </div>
          </div>
          <div class="space-y-4">
            <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
              <span class="text-slate-400 text-sm"></span>
              <span class="text-blue-400 font-mono text-sm font-bold"></span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold"> TOTAL WITHDRAW</span>
              <span class="text-cyan-400 text-xs">{upd} USDT</span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">TOTAL COIN WITHDRAW </span>
              <span class="text-cyan-400 text-xs">{tt3} XYZ Token</span>
            </div>
              <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">TOTAL WITHDRAW </span>
              <span class="text-cyan-400 text-xs">{wid1} USDT</span>
            </div>
             <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">PENDING WITHDRAW </span>
              <span class="text-cyan-400 text-xs">{pen} USDT </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               Token
              </p>
            
            </div>
          </div>
          <div class="space-y-4">
           
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">MY TOKENS</span>
              <span class="text-blue-400 text-xs">{pack} XYZ Tokens</span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">MY FREEZE TOKENS </span>
              <span class="text-blue-400 text-xs">{pack3}XYZ Tokens</span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">1 XYZ Token</span>
              <span class="text-blue-400 text-xs">{a3} USDT</span>
            </div>
            
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               Direct
              </p>
              <h3 class="text-white text-lg font-bold"></h3>
            </div>
          </div>
          <div class="space-y-4">
            <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
              <span class="text-slate-400 text-sm">MY DIRECT TEAM</span>
              <span class="text-blue-400 font-mono text-sm font-bold">{direct}</span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">MY DIRECT INCOME</span>
              <span class="text-purple-400 text-xs">{directs} USDT</span>
            </div>
             <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">DIRECT BUSINESS</span>
              <span class="text-purple-400 text-xs">{direct1} USDT</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               MY PURCHASE
              </p>
              <h3 class="text-white text-lg font-bold">{pack1} USDT</h3>
            </div>
          </div>
        
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-cyan-500/50 to-transparent shadow-[0_0_25px_rgba(6,182,212,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#081b25]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-cyan-400 text-[1rem] font-bold uppercase tracking-widest"
              >
              REWARD 
              </p>
              <h3 class="text-white text-lg font-bold">{reward} USDT</h3>
            </div>
          </div>
          <div class="space-y-4">
            <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
              <span class="text-slate-400 text-sm"></span>
              <span class="text-blue-400 font-mono text-sm font-bold"></span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">LEVEL INCOME</span>
              <span class="text-cyan-400 text-xs">{lev} USDT</span>
            </div>
           
          </div>
        </div>
      </div>
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Bonus
              </p>
             
            </div>
          </div>
          <div class="space-y-4">
            <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
              <span class="text-slate-400 text-sm">TOTAL BONUS </span>
              <span class="text-[#4ade80] font-mono text-sm font-bold"
                >{tt} USDT</span
              >
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">CURRENT WEEK BONUS </span>
              <span class="text-blue-400 text-xs">{tt4} USDT</span>
            </div>
          </div>
        </div>
      </div>

    
        <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level1
              </p>
              <h3 class="text-white text-lg font-bold"></h3>
            </div>
          </div>
          <div class="space-y-4">
           
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 1 Users</span>
              <span class="text-purple-400 text-xs">{l1}</span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 1 Business </span>
              <span class="text-purple-400 text-xs">{b1} USDT</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 2
              </p>
           
            </div>
          </div>
          <div class="space-y-4">
           
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 2 Users</span>
              <span class="text-pink-400 text-xs">{l2}</span>
            </div>
            
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 2 Business</span>
              <span class="text-pink-400 text-xs"> {b2} USDT</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-cyan-500/50 to-transparent shadow-[0_0_25px_rgba(6,182,212,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#081b25]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-cyan-400 text-[1rem] font-bold uppercase tracking-widest"
              >
              Level 3 
              </p>
             
            </div>
          </div>
          <div class="space-y-4">
            <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
              <span class="text-slate-400 text-sm"></span>
              <span class="text-blue-400 font-mono text-sm font-bold"></span>
            </div>
           
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 3 Users</span>
              <span class="text-cyan-400 text-xs">{l3} </span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 3 Business</span>
              <span class="text-cyan-400 text-xs">{b3} USDT</span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               Level 4
              </p>
              
            </div>
          </div>
          <div class="space-y-4">
          
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold"> Level 4 Users</span>
              <span class="text-blue-400 text-xs">{l4} </span>
            </div>
             <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 4 Business</span>
              <span class="text-blue-400 text-xs"> {b4} USDT </span>
            </div>
          </div>
        </div>
      </div>
        <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 5
              </p>
              <h3 class="text-white text-lg font-bold"></h3>
            </div>
          </div>
          <div class="space-y-4">
           
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 5 Users</span>
              <span class="text-purple-400 text-xs">{l5}</span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 5 Business</span>
              <span class="text-purple-400 text-xs">{b5} USDT</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 6  
              </p>
           
            </div>
          </div>
          <div class="space-y-4">
           
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 6 Users </span>
              <span class="text-pink-400 text-xs"> {l6}</span>
            </div>
            
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 6 Business</span>
              <span class="text-pink-400 text-xs">{b6}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-cyan-500/50 to-transparent shadow-[0_0_25px_rgba(6,182,212,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#081b25]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-cyan-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                 Level 7 
              </p>
             
            </div>
          </div>
          <div class="space-y-4">
            <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
              <span class="text-slate-400 text-sm"></span>
              <span class="text-blue-400 font-mono text-sm font-bold"></span>
            </div>
           
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 7 Users</span>
              <span class="text-cyan-400 text-xs">{l7}</span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold"> Level 7 Business</span>
              <span class="text-cyan-400 text-xs"> {b7} USDT </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               Level 8 
              </p>
              
            </div>
          </div>
          <div class="space-y-4">
          
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 8 Users</span>
              <span class="text-blue-400 text-xs">{l8}</span>
            </div>
             <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 8 Business</span>
              <span class="text-blue-400 text-xs"> {b8} USDT</span>
            </div>
          </div>
        </div>
      </div>
        <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-cyan-500/50 to-transparent shadow-[0_0_25px_rgba(6,182,212,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#081b25]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-cyan-400 text-[1rem] font-bold uppercase tracking-widest"
              >
             Level 9 
              </p>
             
            </div>
          </div>
          <div class="space-y-4">
            <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
              <span class="text-slate-400 text-sm"></span>
              <span class="text-blue-400 font-mono text-sm font-bold"></span>
            </div>
           
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 9 Users</span>
              <span class="text-cyan-400 text-xs">{l9}</span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 9 Business</span>
              <span class="text-cyan-400 text-xs">{l10}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               Level 10 
              </p>
              
            </div>
          </div>
          <div class="space-y-4">
          
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">  Level 10 Users</span>
              <span class="text-blue-400 text-xs">{l10} </span>
            </div>
             <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 10 Business</span>
              <span class="text-blue-400 text-xs">  {b10} USDT  </span>
            </div>
          </div>
        </div>
      </div>
        <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 11
              </p>
              <h3 class="text-white text-lg font-bold"></h3>
            </div>
          </div>
          <div class="space-y-4">
           
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 11 Users</span>
              <span class="text-purple-400 text-xs">{l11} </span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 11 Business</span>
              <span class="text-purple-400 text-xs">{b11} USDT</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 12  
              </p>
           
            </div>
          </div>
          <div class="space-y-4">
           
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 12 Users </span>
              <span class="text-pink-400 text-xs"> {l12}</span>
            </div>
            
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 12 Business</span>
              <span class="text-pink-400 text-xs">{b12}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-cyan-500/50 to-transparent shadow-[0_0_25px_rgba(6,182,212,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#081b25]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-cyan-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                 Level 13 
              </p>
             
            </div>
          </div>
          <div class="space-y-4">
            <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
              <span class="text-slate-400 text-sm"></span>
              <span class="text-blue-400 font-mono text-sm font-bold"></span>
            </div>
           
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 13 Users</span>
              <span class="text-cyan-400 text-xs">{l13}</span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold"> Level 13 Business</span>
              <span class="text-cyan-400 text-xs"> {b13} USDT </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               Level 14
              </p>
              
            </div>
          </div>
          <div class="space-y-4">
          
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 14 Users</span>
              <span class="text-blue-400 text-xs">{l14}</span>
            </div>
             <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 14 Business</span>
              <span class="text-blue-400 text-xs"> {b14} USDT</span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-cyan-500/50 to-transparent shadow-[0_0_25px_rgba(6,182,212,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#081b25]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-cyan-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                 Level 15
              </p>
             
            </div>
          </div>
          <div class="space-y-4">
            <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
              <span class="text-slate-400 text-sm"></span>
              <span class="text-blue-400 font-mono text-sm font-bold"></span>
            </div>
           
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">Level 15 Users</span>
              <span class="text-cyan-400 text-xs">{l15}</span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold"> Level 15 Business</span>
              <span class="text-cyan-400 text-xs"> {b15} USDT </span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
              REFER BY
              </p>
              <h3 class="text-white text-lg font-bold"> {refer} </h3>
            </div>
            
          </div>
        
        </div>
      </div>
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
              MY REFER LINK
              </p>
               <h3 class="text-white text-lg font-bold">{referlink} <button><img style={{height:"10px"}}  src ="copy.png" height={"25px"} onClick={() => {
         navigator.clipboard.writeText(referlink);}} /></button> </h3>
              
            </div>
          </div>
     
        </div>
      </div>
        <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
            <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               CONNECTED ACCOUNT 
              </p>
              <h3 style={{wordBreak:"break-all"}} class="text-white text-lg font-bold">{account}  </h3>
            </div>
          </div>
        
        </div>
      </div>

    

   
    
    </section>
	
        

</div>  
  );
}

export default App;